import {Component, componentService, element as $, elements as $$, requestService, services} from '@contorion/core';
import { IProductService } from '../interfaces/product-service.interface';
import {
    ITrackingScriptsService
} from '../../tracking-scripts/interfaces/tracking-scripts-service.interface';
import {Ga4ViewItemEvent} from "../../google/components/Ga4ViewItemEvent.component";
import {ga4EventService} from "../../google/services/ga4-event.service";
import {
    IGa4BundleRedirection,
    IGa4RelatedSetsItem,
} from "../../google/interfaces/ga4-event.interface";

const SELECTOR_PRODUCT_DETAIL: string = '.js-product-detail';
const SELECTOR_PACKAGE_SIZE: string = '.js-packagesize-selector';
const SELECTOR_SKU: string = '.js-sku';
const SELECTOR_VIDEO_WRAPPER: string = '.js-video-wrapper';
const SELECTOR_BUNDLE_COMPONENT_ITEM: string = '.js-bundle-component-item';
const SELECTOR_RELATED_SETS_SECTION: string = '.js-related-sets-section';
const SELECTOR_RELATED_SETS_ITEMS: string = '.js-related-sets-item';

export class ProductDetailComponent extends Component {
    protected productService: IProductService;
    protected trackingScriptsService: ITrackingScriptsService;

    constructor(protected element: HTMLElement) {
        super(element);

        this.init();
    }

    protected async init(): Promise<void> {
        this.trackingScriptsService = await services.get('tracking-scripts-service');
        this.productService = await services.get('product-service');
        this.productService.subscribeUrl(this.onUrlChange.bind(this));
        if(this.bundleComponentItem) {
            this.bundleComponentItem.addEventListener('click', this.bundleComponentItemClickHandler.bind(this));
        }
        if(this.relatedSetsSection) {
            ga4EventService.viewRelatedSets();
        }
        if(this.relatedSetsItems) {
            this.relatedSetsItems.forEach((item:HTMLElement) => {
                item.addEventListener('click', this.relatedSetsItemClickHandler.bind(this))
            })
        }
    }

    protected get packageSize(): HTMLElement {
        return <HTMLElement> $(SELECTOR_PACKAGE_SIZE, this.element);
    }

    protected get sku(): HTMLElement {
        return <HTMLElement> $(SELECTOR_SKU, this.element);
    }

    protected get videoWrapper(): HTMLElement {
        return <HTMLElement> $(SELECTOR_VIDEO_WRAPPER);
    }

    protected get bundleComponentItem(): HTMLElement {
        return <HTMLElement> $(SELECTOR_BUNDLE_COMPONENT_ITEM, this.element);
    }

    protected get relatedSetsSection(): HTMLElement {
        return <HTMLElement> $(SELECTOR_RELATED_SETS_SECTION, this.element);
    }

    protected get relatedSetsItems(): Array<HTMLElement> {
        return $$<HTMLElement>(SELECTOR_RELATED_SETS_ITEMS, this.element);
    }

    protected removeUrlPrefix = (url: string) => {
        return url.replace(/^https?:\/\//, '')
    };

    protected bundleComponentItemClickHandler(event: MouseEvent) {
        const tcVars = window.tc_vars;

        if(tcVars?.product_is_bundle) {
            const target = event.target as HTMLAnchorElement;

            for (const product of tcVars.product_bundle_components) {
                const product_url = this.removeUrlPrefix(product.product_url_page);
                const target_href = this.removeUrlPrefix(target.href);

                if( product_url === target_href) {
                    const bundleComponentRedirectionData: IGa4BundleRedirection = {
                        currency: window.tc_vars.order_currency,
                        value: parseFloat(window.tc_vars.order_amount_ati_with_sf),
                        items: [
                            {
                                item_id: tcVars.product_id,
                                item_name: tcVars.product_name,
                                bundle_id: product.product_bundle_id,
                                item_category: tcVars.product_cat1,
                                item_category2: tcVars.product_cat2,
                                item_category3: tcVars.product_cat3,
                            }
                        ]
                    };

                    ga4EventService.bundleComponentRedirection(bundleComponentRedirectionData);

                    return;
                }
            }
        }
    }

    protected relatedSetsItemClickHandler(event: any) {
        const target = (event.target as HTMLElement).closest(SELECTOR_RELATED_SETS_ITEMS) as HTMLElement;
        if (!target) return;

        const relatedSetsItemData: IGa4RelatedSetsItem = {
            bundle_sku: target.dataset.sku,
            bundle_name: target.dataset.name,
        };

        ga4EventService.relatedSetsItemClick(relatedSetsItemData);

        return;
    }

    protected async load(url: string): Promise<void> {
        const content = await requestService
            .get(url)
            .then((response: Response) => response.text());

        this.replace(content);
    }

    protected replace(content: string): void {
        const vdom: HTMLElement = document.createElement('div');
        vdom.innerHTML = content;

        const newElement = vdom.querySelector(SELECTOR_PRODUCT_DETAIL);
        const tcVarsScript = vdom.querySelector(this.trackingScriptsService.tcVarsScriptSelector);
        const scripts = vdom.querySelector(this.trackingScriptsService.bodyTrackingSelector);
        const skuToUpdateFrom: string = this.sku?.innerText;

        if (!newElement) {
            return;
        }

        this.element.innerHTML = newElement.innerHTML;
        componentService.load(this.element);

        if (this.videoWrapper) {
            componentService.load(this.videoWrapper);
        }

        if (this.sku?.innerText !== skuToUpdateFrom) {
            this.trackingScriptsService.setBodyTrackingScripts(scripts.innerHTML);
            this.trackingScriptsService.updateTcVarsScript(tcVarsScript.innerHTML);
        }

        Ga4ViewItemEvent.loadByElement(this.element);

    }

    protected onUrlChange(url: string): void {
        if (url === null) {
            return;
        }

        this.load(url);
    }
}
